import o from "./_baseCreate.js";
import r from "./_getPrototype.js";
import e from "./_isPrototype.js";
function p(t) {
  return typeof t.constructor == "function" && !e(t) ? o(r(t)) : {};
}
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_initCloneObject.js
// module id = 918
// module chunks = 67